import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild, ElementRef } from "@angular/core";
import { DatePipe } from "@angular/common";
import { FormControl } from "@angular/forms";
import * as _ from "lodash";
import * as XLSX from 'xlsx';
import { Combo2Service, ExcelService, ReportService } from "../../../services/index";
import { SalesOrderService } from "../../../services/salesOrder.service";

@Component({
  selector: "customerOutstandingReport",
  templateUrl: "./customerOutstandingReport.html"
})
export class customerOutstandingReportComponent implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild('table') table: ElementRef;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  typeCtrl: FormControl = new FormControl();
  orderCtrl: FormControl = new FormControl();
  isLoadMask: Promise<any>;

  seasonList = [];
  seasonyearList = [];
  seasonfinList = [];
  exceldata: any;
  year_id: any;

  salesPerson = "";
  reportDate = new Date().toLocaleDateString("fr-FR");
  party: any;
  partywise: any;
  filter = {
    from_date: "",
    to_date: "",
    groupby: "outstanding",
    agent_name: "",
    start_date: new Date(),
    end_date: new Date(),
    fin_id: "",
  };
  partyList: any = [];
  partyLength = 0;
  data: any = [];
  totData: any = [];
  totBillAmt = 0;
  totcalc: any = [];
  finyearList: any;
  partytotamt : any = [];

  constructor(
    private salesPlan: SalesOrderService,
    private combo2Service: Combo2Service,
    private reportService: ReportService,
    public datePipe: DatePipe,
    private excelService: ExcelService
  ) {

  }

  ngOnInit(): void {

    this.finyearCombo();

  }

  // Get the current financial year
  finyearCombo() {
    this.combo2Service.finyearCombo().then((res: any) => {
      this.finyearList = res.data;
      this.finyearCtrl.setValue(res.data[0].fin_id);
      this.year_id = res.data[0].fin_id;
    });
    this.loadOutstandingList();
  }

  onSelectFinyear(id) {
    this.totData.length = 0;
    this.year_id = id;
    let seasonfinList = _.filter(this.seasonList, { fin_id: id });
    this.seasonfinList = seasonfinList;
    this.seasonCtrl.setValue(
      this.seasonList[this.seasonList["length"] - 1].season_id
    );
    this.onSelectdate('ALL');
  }

  // displayFinyear(comboType: string, id: number) {

  //   let list: any = [];
  //   if (comboType == "Finyear") {
  //     list = this.finyearList;
  //     this.findYear(list, id);
  //   }

  //   if (id && list.length > 0) {
  //     let fitem = _.find(list, { fin_id: id });
  //     return fitem["finyear"];
  //   }
  // }

  // findYear(list: any, id: any) {
  //   if (id && list.length > 0) {
  //     let fitem = _.find(list, { fin_id: id });
  //     this.filter.from_date = fitem["start_date"];
  //     this.filter.to_date = fitem["end_date"];
  //   }
  //   this.loadOutstandingList();
  // }

  // Get agentwise List (1st level)
  loadOutstandingList() {
    let that = this;

    let params = {
      filter: JSON.stringify(this.filter),
    };
    that.reportService.getCustomerOutstandingReport(params).then(function (res: any) {
      that.data = res.data;

      if (that.data.length > 0) {
        let totBill = 0,
          totParty = 0,
          totAmt = 0,
          totpendAmt = 0,
          retTot = 0;

        that.data.forEach(element => {

          totBill += element.no_of_bills;
          totParty += element.no_of_parties;
          totAmt += element.bill_amount;
          totpendAmt += element.pend_amount;
          retTot += element.ret_amt;
          
        });

        that.totData.push(
          {
            agent_name: "Total",
            no_of_bills: totBill,
            no_of_parties: totParty,
            bill_amount: totAmt,
            pend_amount: totpendAmt,
            ret_amt: retTot

          });
      }
    });

  }

  // Get partywise List (2nd level)
  loadPartywise(partywise: any) {
    let that = this;
    partywise['from_date'] = this.filter.from_date;
    partywise['to_date'] = this.filter.to_date;
    this.salesPerson = partywise.agent_name;
    let params = {
      filter: JSON.stringify(partywise),
    };
    that.reportService.getCustomerOutstandingReport(params).then(function (res: any) {
      that.data = res.data;
      that.partywise = res.partywise;
      // group by partywise
      that.party = _.groupBy(that.partywise.data, 'party_id');
      that.partyList = Object.values(that.party);
      that.partyLength = that.partyList.length;
    });
    setTimeout(() => {
      this.calc();
    }, 100);
  }

  // calc() {
  //   for (let i = 0; i < this.partyList.length; i++) {
  //     let totbill = 0, totpend = 0;
  //     for (let j = 0; j < this.partyList[i].length; j++) {
  //       totbill += parseInt(this.partyList[i][j].bill_amount);
  //       totpend += parseInt(this.partyList[i][j].outstanding_amount);
  //     }
  //     this.totcalc.push(totbill, totpend);
  //   }
  // }

  // calculate total amount, pending amount and empty the party names for table view purpose
  // and pushed that changed content in next obj of that loop obj
  calc() {
      let totamtobj = {
      party_name: "Grand Total",
      billno:"",
      dcdt:"",
      recamt:"",
      discnt:"",
      totbill: 0,
      totpend: 0,
      retTotal: 0
      };
      this.partytotamt.length = 0;
    // agent - i , party - j
    for (let agent = 0; agent < this.partyList.length; agent++) {

      let totObj = {
        party_name: "Total",
        totbill: 0,
        totpend: 0,
        retTotal: 0
      }
      let partyName = "";
      for (let party = 0; party < this.partyList[agent].length; party++) {
        totObj.totbill += parseInt(this.partyList[agent][party].bill_amount);
        totObj.totpend += parseInt(this.partyList[agent][party].outstanding_amount);
        totObj.retTotal += parseInt(this.partyList[agent][party].ret_amt);

        

        if (this.partyList[agent][party].party_name == partyName) {
          this.partyList[agent][party].party_name = "";
        } else {
          partyName = this.partyList[agent][party].party_name;
        }
      }
      this.partyList[agent].push(totObj);

      totamtobj.totbill += totObj.totbill;
      totamtobj.totpend += totObj.totpend;
      totamtobj.retTotal += totObj.retTotal;


    }
    this.partytotamt.push(totamtobj);
  }

  // show and hidden the table 1 and table 2
  onbackbutton() {
    this.partyLength = 0;
  }

  onSelectdate(type) {
    if (type == "ALL") {

      let id = this.year_id;
      let data = this.seasonyearList;
      let obj_data = data.filter(o => o.fin_id == id);
      let obj = obj_data.filter(o => o.season !== type);
      this.filter.from_date = obj[0].sales_from;
      this.filter.to_date = obj[obj["length"] - 1].sales_to;

    }
  }

  // export the html elements into excel sheet
  exportToExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(
      this.table.nativeElement
    );
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, 'CoSheet.xlsx');
  }
}




// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/report/OutstandingReport/customerOutstandingReport.ts